import React from 'react';
import userManager from './auth/userManager';
import SerialCheckForm from './components/SerialCheckForm';

// Material UI
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    Button,
    Container
} from '@mui/material';

/**
 * Layout component providing a header (with user info and logout) and footer.
 * Also handles fetching current user data from the OIDC user manager.
 */
function Layout({ children }) {
    const [userName, setUserName] = React.useState('');
    const [userEmail, setUserEmail] = React.useState('');

    // Fetch user data (if logged in) on component mount
    React.useEffect(() => {
        userManager.getUser().then((user) => {
            if (user?.profile) {
                const name = user.profile.name || user.profile.preferred_username || '';
                const email = user.profile.email || '';
                setUserName(name);
                setUserEmail(email);
            }
        });
    }, []);

    /**
     * Logout handler:
     * Either performs an OIDC signout redirect or a direct logout (fallback)!
     */
    const handleLogout = async () => {
        const user = await userManager.getUser();
        if (user) {
            await userManager.signoutRedirect({ id_token_hint: user.id_token });
        } else {
            window.location.href = 'https://copadata.onelogin.com/oidc/2/logout';
        }
    };

    return (
        <>
            {/* HEADER */}
            <AppBar>
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        background: "#202d4f",
                        margin: 0
                    }}
                >
                  
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src="/logo.png"  
                            alt="SLA Checker Logo"
                            style={{ height: "50px" }} 
                        />
                    </Box>

                    {/* User info + Logout button */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ textAlign: "right", marginRight: 2 }}>
                            <Typography sx={{ fontFamily: "Noto Sans", fontWeight: "700", fontSize: "14px" }}>
                                {userName}
                            </Typography>
                            <Typography sx={{ fontFamily: "Noto Sans", fontWeight: "400", fontSize: "14px" }}>
                                {userEmail}
                            </Typography>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                background: "#172139",
                                fontFamily: "Noto Sans",
                                fontWeight: "400",
                                '&:hover': {
                                    background: "#2c3b63"
                                }
                            }}
                            color="inherit"
                            onClick={handleLogout}
                        >
                            Logout
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>


            {/* MAIN CONTENT */}
            <Box component="main" sx={{ flexGrow: 1, mt: 8, mb: 6 }}>
                {children}
            </Box>

            {/* FOOTER */}
            <Box sx={{ flexShrink: 0 }}>
                <AppBar position="fixed" sx={{ top: "auto", bottom: 0, background: "#202d4f" }}>
                    <Toolbar sx={{ justifyContent: "center" }}>
                        <Typography sx={{ fontFamily: "Noto Sans", fontSize: "14px" }}>
                            <b>Internal Automation Services</b> |
                            <a
                                href="mailto:cs-tools@copadata.com"
                                style={{ color: "white", textDecoration: "none", marginLeft: "5px" }}
                            >
                                📧 cs-tools@copadata.com
                            </a>
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    );
}

/**
 * Main application component:
 * Renders the protected SerialCheckForm within the Layout.
 */
function App() {
    return (
        <Layout>
            <Container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '60vh',
                }}
            >
                <SerialCheckForm />
            </Container>
        </Layout>
    );
}

export default App;
